<template>
  <div v-loading="loading">
    <div class="content-list" @click="detailData.activeName ? active = false : ''">
      <el-row>
        <el-col class="left" :span="3">活动名称：</el-col>
        <el-col class="right g-flex-start" :span="20">
          <span v-if="!active">{{ detailData.activeName }}</span>
          <el-input v-else v-model="detailData.activeName" @change="changeName" :maxlength="30" @click.stop.native size="small"></el-input>
          <img v-if="!active" src="../../../../assets/image/modify.png" @click.stop="active = true" alt="">
        </el-col>
      </el-row>
      <el-row>
        <el-col class="left" :span="3">创建时间：</el-col>
        <el-col class="right" :span="20">{{ detailData && detailData.createTime }}</el-col>
      </el-row>
      <el-row>
        <el-col class="left" :span="3">活动油站：</el-col>
        <el-col class="right" :span="20">{{ detailData && detailData.gasName }}</el-col>
      </el-row>
      <el-row v-if="detailData.isFundUsed !== null && detailData.isFundUsed !== undefined">
        <el-col class="left" :span="5">是否使用营销基金：</el-col>
        <el-col class="right" :span="18">{{ detailData.isFundUsed === 0 ? '否' : '是' }}</el-col>
      </el-row>
      <el-row>
        <el-col class="left" :span="3">商家返券：</el-col>
        <el-col class="right" :span="20">{{ detailData.isRebate === 0 ? '否': '是' }}</el-col>
      </el-row>
      <el-row>
        <el-col class="left" :span="3">活动信息：</el-col>
        <el-col class="right" :span="20">
          <rule-card v-for="(item, index) in detailData.activityRegulation" :key="index" :data="item" :index="index" :activeType="9"/>
        </el-col>
      </el-row>
    </div>
    
  </div>
</template>
<script>
import { activeDetail, changeName } from '@/api/marketShop'
import ruleCard from '../../../marketPromotion/components/ruleCard.vue'

export default {
  name: 'limitShopDetail',
  props: ['detailType', 'id', 'show'],
  inject: ['resetData', 'getListData'],
  components: {
    ruleCard
  },
  data () {
    return {
      active: false,
      detailData: {},
      regulationVos: [],
      loading: false
    }
  },
  methods: {
    // 初始化数据
    async initData () {
      this.loading = true
      try {
        const {code, result = {}} = await activeDetail({activeId: this.id})
        if (code !== 200) return
        this.detailData = result.activeInfoNewResponse
        this.loading = false
      } catch (error) {
        console.log(error)
      }
    },
    // 修改活动名称
    async changeName () {
      if (!this.detailData.activeName) {
        this.$message({
          message: '请输入活动名称',
          type: 'warning'
        })
        return
      }

      this.$track.clickEvent('活动营销-活动列表-活动详情-修改名称', '1632832589')

      try {
        const {code} = await changeName({activeName: this.detailData.activeName, activeId: this.id})
        if (code !== 200) return
        this.$message({
          message: '修改成功',
          type: 'success'
        })
        this.active = false
        this.resetData(this.detailType)
        this.getListData(this.detailType)
      } catch (error) {
        console.log(error)
      }
    }
  },
  watch: {
    show (val) {
      val && this.initData()
      this.active = false
    }
  },
  mounted () {
    this.initData()
  }
}
</script>
<style lang="less" scoped>
  @import url('./style.less');
</style>